import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import formTheme from '../../styles/formTheme';
var DobInputContainer = styled.div.withConfig({
  displayName: "DobInputContainer",
  componentId: "sc-1j8iivj-0"
})(["align-items:baseline;background-color:", ";border-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-style:solid;border-width:0 0 1px;display:flex;transition:background 0.3s ease-in 0.1s;z-index:0;", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      skin = _ref.skin;
  return _get(theme, "form.input." + skin + ".backgroundColor", formTheme.form.input[skin].backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme,
      skin = _ref2.skin;
  return _get(theme, "form.input." + skin + ".borderColor", formTheme.form.input[skin].borderColor);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref4) {
  var theme = _ref4.theme;
  return rem(_get(theme, 'form.input.borderRadius', formTheme.form.input.borderRadius));
}, function (_ref5) {
  var active = _ref5.active,
      skin = _ref5.skin,
      theme = _ref5.theme;
  return active && css(["background-color:", ";"], _get(theme, "form.input." + skin + ".backgroundColorFocus", formTheme.form.input[skin].backgroundColorFocus));
}, function (_ref6) {
  var readOnlyValue = _ref6.readOnlyValue;
  return readOnlyValue && css(["border-color:transparent;"]);
}, function (_ref7) {
  var disabledValue = _ref7.disabledValue,
      theme = _ref7.theme,
      skin = _ref7.skin;
  return disabledValue && css(["border-color:", ";border-style:dotted;color:", ";"], _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled), _get(theme, "form.input." + skin + ".colorDisabled", formTheme.form.input[skin].colorDisabled));
});
export default DobInputContainer;